export const INCODE_VERIFICATION_DOCUMENTS_STATUS = {
  COMPLETED: 'completed',
  CONTINUE: 'continue',
  START: 'start',
} as const;

export const INCODE_SESSION_VERIFICATION_STATUS = {
  COMPLETED: 'completed',
  FAILED: 'failed',
  PENDING: 'pending',
} as const;
